// home
import axios from './axios.js'

// 门店分类新增数据
export function addList(data) {
    return axios.post('/shop_category/add', data)
}

// 门店获取二维吗
export function getImg(shopId) {
    return axios.get(`mall/create_qr?shopId=${shopId}`)
}
// 门店获小程序吗
export function getImgs(shopId) {
    return axios.get(`mall/create_qr_wx?shopId=${shopId}`)
}

// 门店分类删除
export function delList(id) {
    return axios.delete(`/shop_category/deleted?id=${id}`)
}

// 门店分类更新
export function updateList(data) {
    return axios.post('/shop_category/update', data)
}

// 门店分类分页数据
export function pagingdata(data) {
    return axios.post('/shop_category/page', data)
}

// 门店列表数据
export function storesList(limit, page) {
    return axios.get(`/mall/shop/list_data?limit=${limit}&page=${page}`)
}

// 门店列表数据查询
export function storesListSeach(limit, page, name, phone) {
    return axios.get(`/mall/shop/list_data?limit=${limit}&page=${page}&name=${name}&phone=${phone}`)
}

// 审核分页接口
export function auditpagingdata(data) {
    return axios.post('/settle_distribution/page', data)
}

// 审核接口
export function audit() {
    return axios.post('/settle_distribution/settle')
}

// 审核更新接口
export function auditUpdate(data) {
    return axios.post('/settle_distribution/update', data)
}

// 项目管理分页接口
export function projectpagingdata(data) {
    return axios.post('/project/page', data)
}

// 项目管理新增接口
export function projectAdd(data) {
    return axios.post('/project/add', data)
}

// 项目管理更新接口
export function projectUpdate(data) {
    return axios.post('/project/update', data)
}

// 项目管理删除接口
export function projectDel(id) {
    return axios.delete(`project/deleted?id=${id}`)
}

// 门店列表数据
export function getstoresData(limit, page, merchantsId) {
    return axios.get(`/mall/shop/list_data_v2?limit=${limit}&page=${page}&merchantsId=${merchantsId}`)
}

// 所属门店下拉数据
export function mallList(merchantsId) {
  return axios.get(`/mall/shop/mall_list?merchantsId=${merchantsId}`)
}

// 门店列表编辑数据
export function getstoresDataEdit(limit, page, uid) {
    return axios.get(`/mall/shop/list_data_v2?limit=${limit}&page=${page}&uid=${uid}`)
}

export function getEdit(shopId) {
    return axios.get(`/mall/shop/info_page_v2?shopId=${shopId}`)
}

// 首页数据
export function getMainData(data) {
    return axios.get('/common/chart', data)
}

// 三级分销列表
export function getDistribution(limit, page) {
    return axios.get(`/account_recommend/list_data_all?limit=${limit}&page=${page}`)
}

// 三级分销列表搜索
export function getDistributionSeach(limit, page, userNickName, userPhone) {
    return axios.get(`/account_recommend/list_data_all?limit=${limit}&page=${page}&userNickName=${userNickName}&userPhone=${userPhone}`)
}

// 三级分销绑定上级
export function updateDistribution(id, userUid) {
    return axios.get(`/account_recommend/edit_recommend?id=${id}&userUid=${userUid}`)
}

// 获取三级分销佣金绑定
export function getDistributionBinding() {
    return axios.get('/common_config/recommend_rate')
}

// 修改三级分销佣金绑定
export function updateDistributionBinding(rateOne, rateThree, rateTwo) {
    return axios.post(`/common_config/edit_config_recommend?rateOne=${rateOne}&rateThree=${rateThree}&rateTwo=${rateTwo}`)
}

// 会员管理用户拉新
export function userPull(limit, page, uid) {
    return axios.get(`/account_recommend/list_data?limit=${limit}&page=${page}&uid=${uid}`)
}

// 会员管理绑定上级
export function userBindSuperior(aimUidOrPhone, objId) {
    return axios.get(`/consumer/bind_vip?aimUidOrPhone=${aimUidOrPhone}&objId=${objId}`)
}

// 分销商代理审核更新数据
export function distributorsUpdate(data) {
    return axios.post('settle_distribution/update', data)
}

// 分销商代理审核接口
export function distributorsThrough(data) {
    return axios.post('settle_distribution/settle', data)
}

// 分销商代理审核下拉框数据
export function distributorsXiala() {
    return axios.get('settle_distribution/shop_list')
}

// 分销商代理审核编辑明细数据
export function distributorsInfo(objId) {
    return axios.get(`settle_distribution/info?objId=${objId}`)
}

// 提现审核提现通过与不同过
export function withdrawalAudit(data) {
    return axios.post(`finance_clear/deal`, data)
}

// 三级分销修改上级
export function updatesuperior(id, userUid) {
    return axios.get(`account_recommend/edit_recommend?id=${id}&userUid=${userUid}`)
}

// 门店列表新增门店
export function addStoreList(data) {
    return axios.post('mall/settled', data)
}
// 门店列表修改
export function modifyEdit(data) {
    return axios.post('/mall/shop/edit', data)
}

// 默认门店修改
export function editDefaultFlag(data) {
  return axios.post('/mall/shop/editDefaultFlag', data)
}

// 门店上下架
export function editSettledStatus(objId,shopId) {
  return axios.post(`/mall/shop/shopEditSettledStatus?id=${objId}&shopId=${shopId}`)
}

// 门店列表修改兑换类型
export function editExchangeType(data) {
  return axios.post('/mall/shop/editExchangeType', data)
}

// 门店列表修改货币互通
export function editGeneralFlag(data) {
  return axios.post('/mall/shop/editGeneralFlag', data)
}

// 门店列表新增门店分类下拉框
export function storeListEditXiala(data) {
    return axios.post('shop_category/page', data)
}

// 兑换订单确认领取
export function exchangeOk(data) {
    return axios.post('order_lottery/affirm', data)
}

// 兑换订单取消领取
export function exchangeNo(data) {
    return axios.post('order_lottery/cancel', data)
}

// 首页接口门店统计
export function mainStatistical() {
    return axios.get('common/chart_shop')
}

// 首页接口会员统计
export function mainVipStatistical() {
    return axios.get('common/chart_member')
}

// 报表详情接口：统计图，订单相关数据
export function a() {
    return axios.get('common/chart_member')
}

// 用户协议
export function userDetails(type) {
    return axios.get(`common_rich_text/info_page_v2?type=${type}`)
}

// 用户协议更新
export function updateuserDetails(data) {
    return axios.post(`common_rich_text/updata_text`, data)
}

// 首页报表数据 统计图 订单数据
export function mainInfo(data) {
    return axios.post(`common/info`, data)
}

// 首页报表数据接口
export function mainTablelInfo(limit, page) {
    return axios.get(`common/activity_form?limit=${limit}&page=${page}`)
}

// 首页站内信接口
export function mainTableTwolInfo(limit, page) {
    return axios.get(`common_message/message?limit=${limit}&page=${page}`)
}

// 首页站内信已读
export function yidu(messageIds) {
    return axios.get(`common_message/message_read?messageIds=${messageIds}`)
}

// 获取用户反馈列表数据
export function userList(limit, page) {
    return axios.get(`feedback/list_data?limit=${limit}&page=${page}`)
}

// 获取用户反馈列表搜索
export function userListSeach(limit, page, userPhone, isDeal) {
    return axios.get(`feedback/list_data?limit=${limit}&page=${page}&userPhone=${userPhone}&isDeal=${isDeal}`)
}

// 获取用户反馈列表详情数据
export function userListDetails(objId) {
    return axios.get(`feedback/info_detail?objId=${objId}`)
}

// 获取用户反馈列表数据处理
export function userListDeal(objId, content) {
    return axios.get(`feedback/idea_submit?objId=${objId}&content=${content}`)
}

// 获取用户反馈列表数据处理
export function userListDel(objId) {
    return axios.get(`feedback/del?objId=${objId}`)
}

// 权限馈列表详情数据
export function rightListDetails(data) {
    return axios.post('menu/page', data)
}

// 订单统计
export function count_order(data) {
    return axios.get('/common/count_order', data)
}

// 获取结算周期
export function settlement() {
    return axios.get('/common_config/config_settlement_period')
}

// 结算周期编辑接口
export function settlementEdit(userFinanceCycle) {
    return axios.get(`/common_config/edit_finance_cycle_config?userFinanceCycle=${userFinanceCycle}`)
}

// 提现审核
export function financeAuditSeach(limit, page, financeNo, name) {
    return axios.get(`finance_clear/list_data?limit=${limit}&page=${page}&financeNo=${financeNo}&name=${name}`)
}

// 用户余额搜索
export function userDalanceSeach(limit, page, nickName, phone) {
    return axios.get(`finance_clear/list_data?limit=${limit}&page=${page}&nickName=${nickName}&phone=${phone}`)
}

// 订单收入搜索
export function orderSeach(limit, page, orderNo, nickName, phone, endTime, beginTime) {
    return axios.get(`finance_order/list_data?limit=${limit}&page=${page}&orderNo=${orderNo}&nickName=${nickName}&phone=${phone}&endTime=${endTime}&beginTime=${beginTime}`)
}

// 获取货币通用设置
export function currency(data) {
    return axios.post('mall/currency_data', data)
}

// 获取货币通用编辑设置
export function currencyEdit(record, type) {
    return axios.get(`mall/currency_edit?record=${record}&type=${type}`)
}

// 财务订单流水搜索
export function runningWaterSeach(limit, page, orderNo, beginTime, endTime) {
    return axios.get(`finance_order/list_data?limit=${limit}&page=${page}&orderNo=${orderNo}&beginTime=${beginTime}&endTime=${endTime}`)
}

// 权限管理账号分页数据
export function permissionsList(data) {
    return axios.post('user_admin/page_data', data)
}

// 权限管理账号分页角色名称下拉框
export function permissionsListXiala() {
    return axios.get('menu/role_list')
}

// 商家账号下拉框数据
export function merchantsListSelect() {
  return axios.post('user_admin/merchants_list')
}

// 权限管理账号新增商家账号
export function permissionsAddAccount(data) {
    return axios.post('user_admin/add_user', data)
}

// 权限管理账号编辑商家账号
export function permissionsEditAccount(data) {
    return axios.post('user_admin/edit', data)
}

// 权限管理账号删除商家账号
export function permissionsDelAccount(objId) {
    return axios.get(`user_admin/delete?objId=${objId}`)
}


//角色管理新增角色tree表
export function partManagementList() {
    return axios.get('menu/get_all_route')
}

//角色管理新增角色
export function partManagementAdd(data) {
    return axios.post(`menu/binding`, data)
}

//角色管理修改角色
export function partManagementEdit(data) {
    return axios.post(`menu/update_role_menu`, data)
}

//角色管理新增角色
export function partManagementListTwo(data) {
    return axios.post(`menu/role_page`, data)
}

//角色管理角色禁用
export function partManagementListDisable(roleId, status) {
    return axios.get(`menu/role_status?roleId=${roleId}&status=${status}`)
}

//角色管理删除角色
export function partManagementListTwoDel(id) {
    return axios.get(`menu/deleted_role?id=${id}`)
}

// 门店功能展示列表
export function storeFunction(shopId) {
    return axios.get(`shop/icon/list_data?shopId=${shopId}`)
}

// 门店功能展示列表修改
export function storeFunctionEdit(data) {
    return axios.post(`shop/icon/edit_use`, data)
}

// 商家角色管理批量删除
export function partManagementListDels(roleIdList) {
    return axios.post(`menu/batch_deleted_role`, roleIdList)
}

// 商家门店列表功能编辑
export function functionEdit(data) {
    return axios.post(`shop/icon/edit_use`, data)
}

// 商家门店列表电子会员有效期修改
export function functionEditDate(data) {
    return axios.post(`shop/icon/edit_date`, data)
}

// 商家门店列表功能编辑
export function partManagementHomeInfo(roleId) {
    return axios.get(`menu/role_info?roleId=${roleId}`)
}

// 商家门店列表功能编辑
export function configGetCurrencyAndIntegral() {
  return axios.get(`user_admin/config_get`)
}

// 商家门店列表功能编辑
export function configEditCurrencyAndIntegral(data) {
  return axios.post(`user_admin/config_edit`,data)
}

// 获取角色已选中的权限
export function getRoleMenuByRoleId(roleId) {
  return axios.get(`menu/get_role_menu?roleId=${roleId}`)
}
// 模板消息主表
export function tmplMainList(data) {
  return axios.post("template/main_list", data);
}
// 模板消息分页数据
export function tmplList(data) {
  return axios.post("template/list", data);
}
// 模板消息新增
export function tmplAdd(data) {
  return axios.post("template/add", data);
}
// 模板消息编辑
export function tmplEdit(data) {
  return axios.post(`template/update`, data);
}
// 模板消息删除
export function tmplDel(objId) {
  return axios.get(`template/deleted?id=${objId}`);
}


// 获取用户积分列表搜索
export function userIntergralList(params) {
    return axios.get(`user_integral/list_data`,{
        params:params
    })
}

// 获取用户积分详情数据
export function userIntergralDetails() {
    return axios.get(`user_integral/list_page`)
}

// 获取商户用户积分总额
export function userIntergralTotal() {
    return axios.get(`user_integral/getAllUserIntegralBalance`)
}

// 门店签到记录数据
export function SigninRecord() {
    return axios.post(`user_integral/set`)
}

// 门店签到记录数据修改
export function SigninRecordEdit(data) {
    return axios.post(`user_integral/edit`, data)
}
// 用户签到数据列表
export function userSignin(data) {
    return axios.post(`user_integral/user_sign_list`, data)
}

// 用户剩余积分明细列表
export function userIntergralDetail(data) {
    return axios.post(`user_integral/detail`, data)
}

// 代币套餐列表
export function getSeachList(limit, page, typeId, typeSonId, name,shopId) {
    return axios.get(`goods/list_data?limit=${limit}&page=${page}&typeId=${typeId}&typeSonId=${typeSonId}&name=${name}&shopId=${shopId}`)
}
// 代币套餐列表
export function getTokensList(limit, page, typeId, typeSonId) {
    return axios.get(`goods/list_data?limit=${limit}&page=${page}&typeId=${typeId}&typeSonId=${typeSonId}`)
}

// 套餐操作日志列表
export function listGoodsMallLog(limit, page,operationType,shopId) {
  return axios.get(`goods/list_goods_mall_log?limit=${limit}&page=${page}&operationType=${operationType}&shopId=${shopId}`)
}

// 套餐操作日志列表
export function listGoodsMallLogAll(limit, page,operationType) {
  return axios.get(`goods/list_goods_mall_log?limit=${limit}&page=${page}&operationType=${operationType}`)
}

// 套餐操作日志详情
export function infoGoodsMallLog(id) {
  return axios.get(`goods/info_goods_mall_log?id=${id}`)
}

// 商户：新增代币套餐列表
export function addTokensList(data) {
    return axios.post('goods/add_edit', data)
}

// 按门店：编辑代币套餐列表
export function editTokensList(data) {
    return axios.post('goods/add_edit_byStore', data)
}

// 按门店：编辑代币套餐
export function detailTokensList(objId) {
    return axios.get(`goods/info?objId=${objId}`)
}

// 按门店：删除代币套餐列表
export function delTokensList(objId) {
    return axios.get(`goods/del_byStore?objId=${objId}`)
}

// 商户：删除代币套餐列表
export function delTokensListByMerchantsId(skuId) {
    return axios.get(`goods/del?skuId=${skuId}`)
}

// 批量删除代币套餐列表
export function delsTokensList(idList) {
    return axios.post('goods/batch_del', idList)
}

// 门店管理商品是否上下架
export function storeUpdown(objId, shelf,shopId) {
    return axios.get(`goods/shelf_recommend_byStore?objId=${objId}&shelf=${shelf}&shopId=${shopId}`)
}

// 商户：门店管理商品是否上下架
export function storeUpdownByMerchants(skuId, shelf) {
    return axios.get(`goods/shelf_recommend?skuId=${skuId}&shelf=${shelf}`)
}

//获取门店列表
export function getStoreList() {
  return axios.get(`goods/store_info`)
}

// 华为云图片上传接口
export function picUpload(data) {
    return axios.post('/open/upload_file', data)
}

// 门票套餐下拉框接口,项目名称
export function ticketXiala(data) {
    return axios.post('project/page', data)
}

// 门店项目管理列表新增接口
export function storeClassificationAdd(data) {
    return axios.post("merchants/project/add", data)
}

// 门店项目管理列表删除接口
export function storeClassificationDel(id) {
    return axios.get(`merchants/project/deleted?id=${id}`)
}
// 门店项目管理列表删除接口
export function storeClassificationDels(ids) {
    return axios.get(`merchants/project/deleted_list?ids=${ids}`)
}

// 门店项目管理列表编辑接口
export function storeClassificationEdit(data) {
    return axios.post("merchants/project/update", data)
}
// 门店项目管理列表接口
export function storeClassification(data) {
    return axios.post("merchants/project/page", data)
}

// 已支付订单退款
export function payOrderRefund(data) {
  return axios.post(`order_mall/refund?orderId=${data.orderId}&fun=${data.fun}&uid=${data.uid}&refundAmount=${data.refundAmount}`)
}

// 一键删除门店订单
export function payOrderDel(tranDate,shopId) {
  return axios.delete(`order_main/delete_order?tranDate=${tranDate}&storeId=${shopId}`)
}

// 一键删除门店兑换记录
export function payOrderDelExchange(tranDate,shopId) {
    return axios.delete(`order_lottery/order_delete?tranDate=${tranDate}&shopId=${shopId}`)
}

// 一键解绑门店会员
export function unbindStoreMember(tranDate,shopId) {
  return axios.delete(`account_login_check/unbind?shopId=${shopId}&tranDate=${tranDate}`)
}

// 日志查询
export function userLogSeach(data) {
    return axios.post(`log/list`, data)
}


// 获取汇付支付列表
export function getHuiFuPayList(data) {
    return axios.get(`mall/query_hufu_pay_params`,{
        params: data
    })
}

// 新增、修改汇付支付参数
export function addHuiFuPay(data) {
    return axios.post(`mall/add_edit_hufu_pay_params`, data)
}

// 删除汇付支付参数
export function deleteHuiFuPay(objId) {
    return axios.post(`mall/delete_hufu_pay_params?objId=${objId}`)
}

// 上架汇付支付参数
export function onShelfHuiFuPay(objId,shelf) {
    return axios.post(`mall/update_shelf_hufu_pay_params?objId=${objId}&shelf=${shelf}`)
}


// WEBPACK FOOTER //
// ./src/api/homeApi.js